<template>
  <div class="col-md-12">
    <table width="100%" class="autor-nome-table">
      <tr>
        <td class="autor-nome" style="line-height: 100%; font-size: 25px;">{{autor.nome}}</td>
        <td class="autor-instituicao" valign="bottom" align="right" width="40%">
          <router-link :to="{ name:'trabalhos', params:{ pesquisa:autor.instituicao } }">{{ autor.instituicao }}</router-link>
        </td>
      </tr>
    </table>
    <!-- mais informações do autor -->
    <div class="autor-infos">
      <div class="autor-info"><b>{{ autor.todos_trabalhos.length }}</b> {{ $tc('publicacao', autor.todos_trabalhos.length) }}</div>
      <div class="autor-info"><b>{{ autor.eixos.length }}</b> {{ $tc('eixo_tematico', autor.eixos.length) }}</div>
    </div>

    <!-- faz duas colunas -->
    <!-- uma de trabalhos e outra de eixos -->
    <div class="row">
      <div class="col-md-9">
        <h1>{{ $tc('trabalho', 2) }} <small>({{Object.keys(autor.todos_trabalhos).length}})</small></h1>
        <anais-trabalho-row :trabalho_id="t.id" v-for="t in autor.todos_trabalhos" :key="t.id"></anais-trabalho-row>
      </div>

      <div class="col-md-3 eixos">
        <h1 id="eixos-title">{{ $t('eixos_publicados') | capitalize }} <small>({{autor.eixos.length}})</small></h1>
        <div class="eixo" v-for="e in autor.eixos">
          <router-link :to="{name:'trabalhos', params:{pesquisa:e.nome}}">
            {{e.nome}}
          </router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import removeAccents from 'remove-accents'
import { i18n } from '@/langs/anais'

export default {
  name: 'anaisAutor',
  props: {},
  components: {},
  filters: {},
  watch: {},
  computed: {
    autor() {
      if(this.$route.params.autor_id) {
        let autor_id = this.$route.params.autor_id
        let ret = this.autores.find(a => a.id == autor_id)
        if(!ret) {
          // não encontrei o autor
          // volto para autores
          this.$router.replace('/autores')
          return this.autores[0]
        }
        return ret
      }
      return this.autores[0]
    },

    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos() { return eixos }, autores() { return autores }, palavras_chaves() { return palavras_chaves }, trabalhos() { return trabalhos },
  },
  created() {},
  mounted() {},
  methods: {},
  i18n: i18n
}
</script>

<style type="text/css" scoped>
  /* A é autor
  mas é o autor da lista de autores*/
  .autor {
    padding: 0 10px;
    margin: 40px 0;
    border: 1px solid #333;
    border-top: 0;
    border-left: 0;
    cursor: pointer;
    display: block;
  }
  .autor:hover {
    box-shadow: 0px 0px 8px #CCC;
  }
  .autor-nome {
    font-size: 32px;
    padding: 10px 0;
    color: black;
  }
  .autor:hover .autor-nome {
    text-decoration: underline;
  }
  .autor-infos {
    border-top: 1px solid #CCC;
  }
  .autor-info {
    display: inline-block;
    margin: 10px;
    margin-left: 0;
  }


  /*agora são as classes
  de quem tá visualizando um autor só*/
  .autor-nome {
    color: black;
    font-size: 32px;
    padding-top: 20px;
    padding-bottom: 9px;
  }
  .autor-instituicao {
    font-size: 14px;
    color: unset;
  }
  .autor-nome-table {
    border-bottom: 1px solid #BBB;
  }

  .eixos {
    border-left: 3px solid #333;
  }
  .eixo {
    border-top: 3px solid #333;
    margin-left: -15px;
    padding-left: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: justify;
  }
  #eixos-title {
    margin-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// AnaisAutor.vue?7a778de8